import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { List } from '../../../..'
import PromoItem from './PromoItem'

class PromoList extends Component {
    static propTypes = {
        promos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        channelId: PropTypes.number,
        onDropMedia: PropTypes.func,
        onFinishSubmit: PropTypes.func,
        reloadPromo: PropTypes.func.isRequired,
        devices: PropTypes.arrayOf(PropTypes.shape({})),
    }

    promos = () => {
        const { promos } = this.props
        return promos || []
    }

    restartDevicesApp = async () => {
        const { devices, reloadPromo } = this.props
        try {
            await Promise.all(
                devices?.map(async ({ id }, index) => {
                    setTimeout(async () => {
                        if (id) {
                            reloadPromo(id)
                        }
                    }, index * 1000)
                })
            )
        } catch (e) {
            console.error(e)
        }
    }

    renderMedia = (keyBuilt = '') => {
        const { onFinishSubmit, channelId } = this.props
        const promos = this.promos()

        // Built key is defined as `<index>_<id>`, so taking the id from it
        const id = parseInt(keyBuilt.split('-').pop(), 10)

        // Looking for the selected media to render
        const promoToRender = promos.find((m) => m.id === id)

        if (!promoToRender) {
            return null
        }

        return <PromoItem key={id} promo={promoToRender} closeModal={onFinishSubmit} channelId={channelId} restartAfterDelete={this.restartDevicesApp} />
    }

    render() {
        const { promos, onDropMedia } = this.props
        const buildKey = (index) => `${index}-${promos[index].id}`
        return (
            <List
                buildKey={buildKey}
                data={promos}
                draggable={!!onDropMedia}
                itemRenderer={this.renderMedia}
                marginBottom="6px"
                onDrop={onDropMedia}
                onRemove={this.onRemoveMedia}
                width="100%"
                display="name"
            />
        )
    }
}

export default PromoList
